import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import CareerDetails from "./CareerDetails";

const CareerDetailsWrapper = () => {
  const location = useLocation();
  const detailData = location.state;

  if (!detailData) {
    // Redirect back if no data (protect against page refresh without state)
    return <Navigate to="/" />;
  }

  return (
    <CareerDetails
      title={detailData.title}
      subtitle={detailData.subtitle}
      sections={detailData.sections}
    />
  );
};

export default CareerDetailsWrapper;
